module.exports = __webpack_public_path__ + "static/media/18.5ada984d.png";